export default [
  {
    path: "/project/:proj_id",
    component: () => import("@/layouts/ProjectLayout.vue"),
    meta: {
      authRequired: true,
    },
    children: [
      {
        path: "field/info/:type",
        name: "field-info-type",
        meta: {
          activeCode: "field-info",
        },
        component: () => import("@/views/_BS/FieldInfo.vue"),
      },

      // ========== 종사자일괄등록 ==========
      {
        path: "employees",
        name: "employees",
        meta: {
          activeCode: "employees",
        },
        component: () => import("@/views/_BS/Employees.vue"),
      },

      // ========== 위험성평가 엑셀 업로드 ==========
      {
        path: "riskassessment450",
        name: "riskassessment450",
        meta: {
          activeCode: "riskassessment450",
        },
        component: () => import("@/views/_BS/RiskAssessment.vue"),
      },
      {
        path: "riskassessment460",
        name: "riskassessment460",
        meta: {
          activeCode: "riskassessment460",
        },
        component: () => import("@/views/_BS/RiskAssessment.vue"),
      },

      // ==========  ==========
      {
        path: "company/info",
        name: "company-info",
        meta: {
          activeCode: "company-info",
        },
        component: () => import("@/views/_BS/CompanyInfo.vue"),
      },
    ],
  },
];
